import React, { useState } from "react";
import { Box, Button, Flex, Heading, Text, Spinner } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";

interface InductionVideoProps {
  onClose: () => void;
  videoUrl?: string;
  stepTitle?: string;
}

export function InductionVideo({ onClose, videoUrl, stepTitle }: InductionVideoProps) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <Flex minH="100dvh" w="100%" direction="column" align="center" justify="center" mt={6}  px={{ base: 4, md: 8 }} py={{ base: 4, md: 6 }} boxSizing="border-box">
      <Box w="100%" >
        

      
          <Box  w="100%"  aspectRatio={16 / 9}  overflow="hidden"  borderRadius="14px"  bg="#0F172A"  position="relative"  display="flex"  alignItems="center"  justifyContent="center">
            {loading && !error && (
              <Flex position="absolute" inset={0} align="center" justify="center" bg="rgba(15, 23, 42, 0.6)" zIndex={2}>
                <Spinner size="xl" color="#10B981" thickness="4px" />
              </Flex>
            )}

            {error ? (
              <Flex direction="column" align="center" justify="center" p={6} textAlign="center" color="white" zIndex={3}>
                <Text fontSize="28px" mb={2}>⚠️</Text>
                <Text fontSize="16px" fontWeight={600} mb={1}>Unable to load video</Text>
                <Text fontSize="13px" color="#94A3B8" maxW="400px" mb={4}>
                  The video file could not be streamed. Please check your network connection or contact HR.
                </Text>
                <Button size="sm" colorScheme="green" onClick={() => { setError(false); setLoading(true); }}>
                  Retry
                </Button>
              </Flex>
            ) : (
              <video
                controls
                autoPlay
                playsInline
                preload="auto"
                src={videoUrl}
                key={videoUrl}
                onLoadedData={() => setLoading(false)}
                onCanPlay={() => setLoading(false)}
                onError={() => {
                  setLoading(false);
                  setError(true);
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  display: "block",
                  objectFit: "contain",
                }}
              >
                Your browser does not support video playback.
              </video>
            )}
          </Box>
        </Box>
    
    </Flex>
  );
}
